import Vue from 'vue';

/**
 * Simple vue instance that is used as event communication bus to components 
 * that are not directly relacionated on the components inheritance tree.
 * 
 * Its allow to use the vue like sintax $on and $emit in every single component 
 * of the app.
 */
export default new Vue();